import { inject, Injectable } from "@angular/core";

import { MessageService } from "primeng/api";

import { MessageType } from "@shared/enums";

@Injectable({
  providedIn: "root",
})
export class ErrorHandlingService {
  messageService = inject(MessageService);

  sendMessage(messageType: MessageType): void {
    switch (messageType) {
      case MessageType.Saved:
        this.messageService.clear();
        this.messageService.add({
          summary: "Saved",
          detail: "Data saved successfully.",
          severity: "success",
          key: "noReply",
        });
        break;
      case MessageType.ServerError:
        this.messageService.clear();
        this.messageService.add({
          summary: "Server Error",
          detail: "Try again later or send feedback.",
          severity: "error",
          key: "reply",
        });
        break;
      case MessageType.AwaitingResponse:
        this.messageService.clear();
        this.messageService.add({
          summary: "Still Working",
          detail: "Awaiting response from server.",
          severity: "info",
          key: "noReply",
        });
        break;
      case MessageType.NotFound:
        this.messageService.clear();
        this.messageService.add({
          summary: "Missing Data",
          detail: "The requested data could not be found.",
          key: "noReply",
          severity: "warn",
        });
        break;
      case MessageType.UpdateRecordNotFound:
        this.messageService.clear();
        this.messageService.add({
          summary: "Save Aborted",
          detail: "The record to be updated could not be found.",
          key: "noReply",
          severity: "error",
        });
        break;
      case MessageType.StillLoading:
        this.messageService.clear();
        this.messageService.add({
          summary: "Still Loading",
          detail: "Please wait while the data loads.",
          severity: "info",
          key: "noReply",
        });
        break;
      case MessageType.Offline:
        this.messageService.clear();
        this.messageService.add({
          summary: "Offline",
          detail: "Please check your connection and try again.",
          severity: "info",
          key: "noReply",
        });
        break;
      default:
        this.messageService.clear();
        this.messageService.add({
          summary: "Unknown Error",
          detail: "An error occured. Please try again later.",
          severity: "error",
          key: "noReply",
        });
        break;
    }
  }
}
